import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NotificationBell from './NotificationBell';
import './Navbar.css';

const Navbar = () => {
  const { user, logout, hasModuleAccess } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getRoleDisplay = () => {
    if (!user || !user.roles) return 'Utilisateur';
    
    if (user.roles.includes('ROLE_RH')) return 'RH';
    if (user.roles.includes('ROLE_MANAGER')) return 'Manager';
    return 'Utilisateur';
  };
  const [logoUrl, setLogoUrl] = React.useState(`${process.env.PUBLIC_URL || ''}/logo_sirep.png`);

  const isActive = (path) => location.pathname === path;

  const [openMenu, setOpenMenu] = React.useState(null);

  const toggleMenu = (menuKey) => {
    setOpenMenu((prev) => (prev === menuKey ? null : menuKey));
  };

  return (
    <nav className="navbar">
      {logoUrl && (
        <img src={logoUrl} alt="Logo" className="navbar-logo-fixed" />
      )}
      <div className="navbar-content">
        <div className="navbar-brand">
          
          <h2>RH - Gestion du Personnel</h2>
        </div>
        
        <nav className="navbar-nav">
        {hasModuleAccess('DASHBOARD') && (
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
            >
              Dashboard
            </Link>
          )}
          {hasModuleAccess('EMPLOYEES') && (
            <div
              className="nav-group"
              onMouseEnter={() => setOpenMenu('employees')}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <span
                className={location.pathname.startsWith('/employees') || location.pathname.startsWith('/grade-progression') ? 'nav-link active nav-group-title' : 'nav-link nav-group-title'}
                onClick={() => toggleMenu('employees')}
              >
                Employés
              </span>
              <div
                className={`nav-submenu ${openMenu === 'employees' ? 'open' : ''}`}
                onMouseEnter={() => setOpenMenu('employees')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                {hasModuleAccess('EMPLOYEES') && (
                  <Link 
                    to="/employees" 
                    className={isActive('/employees') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Employés
                  </Link>
                )}
                {hasModuleAccess('GRADE_PROGRESSION') && (
                  <Link 
                    to="/grade-progression" 
                    className={isActive('/grade-progression') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Promotions
                  </Link>
                )}
              </div>
            </div>
          )}

          {/* Sous-menu Congés */}
          {hasModuleAccess('LEAVES') && (
            <div
              className="nav-group"
              onMouseEnter={() => setOpenMenu('conges')}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <span
                className={location.pathname.startsWith('/leaves') || location.pathname.startsWith('/holidays') ? 'nav-link active nav-group-title' : 'nav-link nav-group-title'}
                onClick={() => toggleMenu('conges')}
              >
                Congés
              </span>
              <div
                className={`nav-submenu ${openMenu === 'conges' ? 'open' : ''}`}
                onMouseEnter={() => setOpenMenu('conges')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                {hasModuleAccess('LEAVES') && (
                  <Link 
                    to="/leaves" 
                    className={isActive('/leaves') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Congés
                  </Link>
                )}
                {hasModuleAccess('HOLIDAYS') && (
                  <Link 
                    to="/holidays" 
                    className={isActive('/holidays') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Jours chômés
                  </Link>
                )}
              </div>
            </div>
          )}

          {hasModuleAccess('TIMESHEETS') && (
            <div
              className="nav-group"
              onMouseEnter={() => setOpenMenu('pointage')}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <span
                className={location.pathname.startsWith('/timesheets') || location.pathname.startsWith('/zkteco') ? 'nav-link active nav-group-title' : 'nav-link nav-group-title'}
                onClick={() => toggleMenu('pointage')}
              >
                Pointage
              </span>
              <div
                className={`nav-submenu ${openMenu === 'pointage' ? 'open' : ''}`}
                onMouseEnter={() => setOpenMenu('pointage')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                {hasModuleAccess('TIMESHEETS') && (
                  <Link 
                    to="/timesheets" 
                    className={isActive('/timesheets') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Pointages
                  </Link>
                )}
                {hasModuleAccess('ZKTECO_AGENTS') && (
                  <>
                    <Link 
                      to="/zkteco/agents" 
                      className={isActive('/zkteco/agents') ? 'nav-sublink active' : 'nav-sublink'}
                    >
                      Agents ZKTeco
                    </Link>
                  </>
                )}
                {hasModuleAccess('ZKTECO_ATTENDANCE') && (
                  <>
                    <Link 
                      to="/zkteco/attendance" 
                      className={isActive('/zkteco/attendance') ? 'nav-sublink active' : 'nav-sublink'}
                    >
                      Validation ZKTeco
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}

          {hasModuleAccess('PAYROLLS') && (
            <div
              className="nav-group"
              onMouseEnter={() => setOpenMenu('paie')}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <span
                className={location.pathname.startsWith('/payroll') || location.pathname.startsWith('/declarations') ? 'nav-link active nav-group-title' : 'nav-link nav-group-title'}
                onClick={() => toggleMenu('paie')}
              >
                Paie
              </span>
              <div
                className={`nav-submenu ${openMenu === 'paie' ? 'open' : ''}`}
                onMouseEnter={() => setOpenMenu('paie')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                {hasModuleAccess('PAYROLLS') && (
                  <Link 
                    to="/payrolls" 
                    className={isActive('/payrolls') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Paie
                  </Link>
                )}
                {hasModuleAccess('DECLARATIONS') && (
                  <Link 
                    to="/declarations" 
                    className={isActive('/declarations') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Déclarations
                  </Link>
                )}
                {hasModuleAccess('PAYROLL_CLOSURES') && (
                  <Link 
                    to="/payroll-closures" 
                    className={isActive('/payroll-closures') ? 'nav-sublink active' : 'nav-sublink'}
                  >
                    Clôture paie
                  </Link>
                )}
              </div>
            </div>
          )}
          {hasModuleAccess('SELF_SERVICE') && (
            <Link 
              to="/mon-espace" 
              className={location.pathname === '/mon-espace' ? 'nav-link active' : 'nav-link'}
            >
              Mon espace
            </Link>
          )}
          
        </nav>
        
        <div className="navbar-user">
          <NotificationBell />
          <div className="user-info">
            <span className="username">{user?.username}</span>
            <span className="user-role">{getRoleDisplay()}</span>
          </div>
          <button onClick={handleLogout} className="btn-logout">
            Déconnexion
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

